// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"089a40b7","885":"2bc06b45"}[chunkId] + ".chunk.js";
};